import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
import { changePostParam } from '@/util/changePostParam';

const serverUrl = publishObjectPath.serverUrl;
const qs = require('qs');
const conttype = 'application/x-www-form-urlencoded';

export class RoleServe {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 分页查询所有菜单数据
  public getRoleDataList(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceRole';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 查询所有菜单数据
  public getRoleDataListAll(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceRole/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增数据
  public addRoleData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceRole';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改数据
  public editRoleData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceRole';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 删除菜单数据
  public deleteRoleData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceRole';
    return this.rSerivce.serverObj.delete(url, {
      params: opts,
    });
  }

  // 通过 id 获取单个数据
  public getRoleLineData(id: string) {
    const url = serverUrl + '/api/spaceManage/spaceRole/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 查询所有数据
  public getAllRoleData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spaceRole/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
}
